class WebSocketManager {
    constructor() {
      if (!WebSocketManager.instance) {
        this.socket = null;
        this.userId = null;
        this.token = null;
        this.reconnectInterval = 5000;
        this.reconnectAttempts = 0;
        this.listeners = [];
        WebSocketManager.instance = this;
      }
      return WebSocketManager.instance;
    }
  
    setCredentials(userId, token) {
      this.userId = userId;
      this.token = token;
      this.connect();
    }
  
    connect() {
      if (this.socket) {
        this.socket.close();
      }
  
      if (!this.userId || !this.token) {
        throw new Error("userId and token must be set before connecting");
      }
  
      const ENDPOINT = "wss://gfmis-sit-hr-api.azurewebsites.us/";
      const socketUrl = `${ENDPOINT}?userId=${this.userId}`;
      this.socket = new WebSocket(socketUrl);
  
      this.socket.onopen = () => {
        console.log('WebSocket connection established');
        this.reconnectAttempts = 0;
      };
  
      this.socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.listeners.forEach(listener => listener(data));
      };
  
      this.socket.onclose = (event) => {
        console.log('WebSocket connection closed', event);
        this.reconnect();
      };
  
      this.socket.onerror = (error) => {
        console.error('WebSocket error', error);
        this.socket.close();
      };
    }

    reconnect() {
      if (this.reconnectAttempts < 10) {
        setTimeout(() => {
          this.reconnectAttempts += 1;
          console.log(`WebSocket Reconnecting attempt ${this.reconnectAttempts}`);
          this.connect();
        }, this.reconnectInterval);
      } else {
        console.error('WebSocket Max reconnect attempts reached');
      }
    }
  
    addListener(callback) {
      this.listeners.push(callback);
    }
  
    removeListener(callback) {
      this.listeners = this.listeners.filter(listener => listener !== callback);
    }
  
    close() {
      if (this.socket) {
        this.socket.close();
      }
    }
  }
  
  const instance = new WebSocketManager();
  export default instance;
  